import React from "react";
import "./DeleteModal.css";
import { reactIcons } from "../../icons/reactIcons";
import Button from "../reusable-button/Button";

interface DeleteModalProps {
  titleHeader: string;
  type: string;
  isOpen: boolean;
  title?: string;
  btnLoader?: boolean;
  handleDelete: (e: React.FormEvent) => void;
  onClose: () => void;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  titleHeader,
  type,
  isOpen,
  title,
  btnLoader,
  handleDelete,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="deletemodal-backdrop">
      <form onSubmit={handleDelete}>
        <div className="deletemodal-container">
          {/* Header */}
          <div className="deletemodal-header">
            <h3>{titleHeader}</h3>
            <button className="deletemodal-close-btn" onClick={onClose}>
              ×
            </button>
          </div>

          {/* Body */}
          <div className="deletemodal-body">
            <div className="deletemodal-icon-main">
              {type === "delete" ? (
                <reactIcons.delete className="deletemodal-flag-icon" />
              ) : (
                <reactIcons.activatePerson className="deletemodal-flag-icon" />
              )}
            </div>

            <p className="deletemodal-body-text">
              {type === "delete" ? (
                <>
                  Are you sure you want to delete this <b>{title}</b>? This
                  action cannot be undone.
                </>
              ) : (
                <>
                  Are you sure you want to {type} <b>{title}</b>?
                </>
              )}
            </p>
          </div>

          {/* Footer */}
          <div className="deletemodal-footer">
            <div className="deletemodal-btn-cancel">
              <Button text="Cancel" onClick={onClose} />
            </div>
            <div className="deletemodal-btn-create">
              <Button text={type} type="submit" loading={btnLoader} />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default DeleteModal;
